import { updateCountryRequest } from "../../data/countryApi";
import { validateCountryPayload } from "../validator/validateCountryPayload";

export async function updateCountryUseCase(payload) {
  const error = validateCountryPayload(payload);

  if (error) {
    throw new Error(error);
  }

  if (!payload?.id) {
    throw new Error("El id es obligatorio.");
  }

  return await updateCountryRequest(payload);
}
